import { render, staticRenderFns } from "./Merchandise.vue?vue&type=template&id=a1213a1e&scoped=true&"
import script from "./Merchandise.vue?vue&type=script&lang=js&"
export * from "./Merchandise.vue?vue&type=script&lang=js&"
import style0 from "./Merchandise.vue?vue&type=style&index=0&id=a1213a1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1213a1e",
  null
  
)

export default component.exports